import { isPro, isClient } from '~~/utils/index'

export default (reqPath: any, req: any) => {
  const config = useRuntimeConfig()
  if (!isPro(config.public.env.NODE_ENV) && !isClient()) {
    import('./logger.config').then(({ requestLog }) => {
      requestLog.info(
        `[Request Info]：${JSON.stringify({
          request: `${req.baseURL}${reqPath}`,
          method: req.method,
          ...req.headers,
        })}`,
      )
    })
  }
}
